<template>
  <report-section 
    title="RR分布" 
    class="rr-distribution-section"
  >
    <template v-slot:content>
      <div class="chart-container">
        <div class="distribution-chart" :id="chartId"></div>
        <div class="x-axis-label">RR(S)</div>
        <div class="y-axis-label">Nbr of beats</div>
      </div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";

export default {
  components: {
    ReportSection
  },

  props: {
    reportDetailModel: Object,
  },

  data() {
    return {
      chartId: "rrDistributionChart",
      chart: null
    };
  },

  mounted() {
    this.$nextTick(() => {
      const chartDom = document.getElementById(this.chartId);
      if (chartDom) {
        this.chart = this.$echarts.init(chartDom);
        this.drawDistribution();
      }
    });
  },

  watch: {
    reportDetailModel() {
      if (this.chart) {
        this.drawDistribution();
      }
    },
  },

  methods: {
    drawDistribution() {
      const distributionData = this.getDistributionData();

      const option = {
        grid: {
          left: '8%',
          right: '5%',
          top: '8%',
          bottom: '12%'
        },
        xAxis: {
          type: 'category',
          data: distributionData.categories,
          axisLine: {
            lineStyle: {
              color: '#BABABA'
            }
          },
          axisLabel: {
            color: '#666',
            fontSize: 12,
            formatter: function(value, index) {
              const numValue = parseFloat(value);
              // 只显示主要的刻度值，减少密集度
              if (numValue === 0.0 || 
                  Math.abs(numValue - 0.5) < 0.02 || 
                  Math.abs(numValue - 1.0) < 0.02 || 
                  Math.abs(numValue - 1.5) < 0.02 || 
                  Math.abs(numValue - 2.0) < 0.02) {
                return numValue.toFixed(1);
              }
              return '';
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#f0f0f0',
              type: 'solid'
            }
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 1641, // 根据图一设置最大值
          interval: 328, // 根据图一设置间隔 (1641/5 ≈ 328)
          axisLine: {
            lineStyle: {
              color: '#BABABA'
            }
          },
          axisLabel: {
            color: '#666',
            fontSize: 12,
            formatter: function(value) {
              // 格式化Y轴标签，添加千位分隔符
              return value.toLocaleString();
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#f0f0f0',
              type: 'solid'
            }
          }
        },
        series: [{
          name: 'RR Distribution',
          data: distributionData.values,
          type: 'bar',
          barWidth: '95%',
          barGap: '0%',
          itemStyle: {
            color: '#4A90E2'
          }
        }],
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            const param = params[0];
            return `RR: ${param.name}s<br/>次数: ${param.value}`;
          }
        }
      };

      if (this.chart) {
        this.chart.setOption(option);
      }
    },

    getDistributionData() {
      if (this.reportDetailModel?.hrvDistributionData && Array.isArray(this.reportDetailModel.hrvDistributionData) && this.reportDetailModel.hrvDistributionData.length > 0) {
        // 处理真实数据
        const dataLength = this.reportDetailModel.hrvDistributionData.length;
        
        // 生成对应的X轴标签（RR间隔值）
        const categories = this.reportDetailModel.hrvDistributionData.map((_, index) => {
          // 根据图片，X轴范围是0.0到2.0，平均分配到数据长度
          const rrValue = (index / (dataLength - 1)) * 2.0;
          return rrValue.toFixed(2);
        });
        
        return {
          categories: categories,
          values: this.reportDetailModel.hrvDistributionData
        };
      }
      
      // 如果没有真实数据，返回空数据
      return {
        categories: [],
        values: []
      };
    }
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>

<style lang="scss" scoped>
.rr-distribution-section {
  /deep/ .report-section-title-text {
    @include report-section-title;
  }
}

.chart-container {
  position: relative;
  width: 100%;
  height: 320px;
}

.distribution-chart {
  @include z-index-2;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.x-axis-label {
  position: absolute;
  right: 3%;
  bottom: 1%;
  font-size: 14px;
  color: #333;
  z-index: 10;
}

.y-axis-label {
  position: absolute;
  left: 2%;
  top: 50%;
  transform: rotate(-90deg) translateX(50%);
  transform-origin: center;
  font-size: 14px;
  color: #333;
  z-index: 10;
}

@media print {
  .rr-distribution-section {
    /deep/ .report-section-title-text {
      @include report-section-title-print;
    }
  }
  
  .chart-container {
    height: 300px;
  }
  
  .x-axis-label {
    bottom: -2% !important;  // 在打印模式下进一步往下调整
  }
}
</style>
